<template>
  <div id="app">
    <MainNavBar />
  </div>
</template>

<script>
import MainNavBar from 'components/navbar/MainNavBar.vue'
import echarts from 'echarts/lib/echarts'

export default {
  name: 'App',
  components: {
	MainNavBar,
  },
  mounted(){
    const dark = {
      backgroundColor: '#121212',
      textStyle: { color: '#e5e5e5' },
      title: { textStyle: { color: '#e5e5e5' }, subtextStyle: { color: '#c5c5c5' } },
      legend: { textStyle: { color: '#c5c5c5' } },
      tooltip: { backgroundColor: '#1e1e1e', borderColor: '#333', textStyle: { color: '#e5e5e5' } },
      axisPointer: { lineStyle: { color: '#888' }, crossStyle: { color: '#888' } },
      grid: { borderColor: '#333' },
      xAxis: [{ axisLine: { lineStyle: { color: '#888' } }, axisLabel: { color: '#c5c5c5' }, splitLine: { lineStyle: { color: '#333' } } }],
      yAxis: [{ axisLine: { lineStyle: { color: '#888' } }, axisLabel: { color: '#c5c5c5' }, splitLine: { lineStyle: { color: '#333' } } }],
      visualMap: { textStyle: { color: '#c5c5c5' } },
      dataZoom: [{ textStyle: { color: '#c5c5c5' } }],
      color: ['#8ab4f8','#f28b82','#fdd663','#81c995','#fff475','#a7ffeb','#b6d7a8','#d7aefb']
    }
    try{ echarts.registerTheme('site-dark', dark) }catch(e){ console.warn('registerTheme failed', e) }
  }
}
</script>

<style>
@import url("assets/css/base.css");
@import url("assets/js/myutils.js");


</style>
